/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontTipiDomandaTipoPresentazione =
  (typeof GetFrontTipiDomandaTipoPresentazione)[keyof typeof GetFrontTipiDomandaTipoPresentazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontTipiDomandaTipoPresentazione = {
  PRIMARIA: 'PRIMARIA',
  SECONDARIA: 'SECONDARIA',
  SISTEMA: 'SISTEMA',
} as const;
